import React, { PropTypes, Component } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { get, post, put, del } from "../../../../apis/utils";
class DynamicRedirect extends React.Component<any, any> {
  componentWillMount() {
    let params = this.props.routerProps.location.pathname.split("/");
    let pathname = params[1];
    let [num, merchant, metric] = ["", "", ""];
    switch (params.length) {
      case 5:
        merchant = params[3];
        metric = params[4];
        break;
      case 4:
        if (isNaN(parseInt(params[3]))) {
          metric = params[3];
        } else {
          merchant = params[3];
        }
    }
    num = params[2];

    get(`/analytics/${pathname}/${num}/${merchant}`)
      .then(function (res) {
        let { flyer_run_ids, end_date, start_date, merchant_id } = res;
        let flyerRuns = flyer_run_ids.join("&flyer_run_ids[]=");
        let redirectURL = `/analytics?end_date=${end_date}&flyer_run_ids[]=${flyerRuns}&merchant=${merchant_id}&start_date=${start_date}&metric=${metric}`;
        location.href = redirectURL;
      })
      .catch((e) => {
        location.href = "/analytics";
      });
  }

  render() {
    return (
      <div
        className="section"
        style={{
          backgroundColor: "white",
          borderRadius: 5,
          height: 500,
          width: 500,
          textAlign: "center",
          marginTop: 100,
          paddingTop: 100,
          marginLeft: "auto",
          marginRight: "auto"
        }}
      >
        <img src="/flipp_empty.png" style={{ height: 200 }} />
        <h3 style={{ marginTop: 50, color: "#00C6D7" }}>
          Hold tight you're being redirected!
        </h3>
      </div>
    );
  }
}

function mapStateToProps(state: any, ownProps: any) {
  return {};
}

export default connect(mapStateToProps)(DynamicRedirect);



// WEBPACK FOOTER //
// ./client/modules/common/components/DynamicRedirect/index.tsx